import { useCallback } from 'react';
import { useTranslation } from '@hooks/useTranslation';
import type { FormTemplateFormEntry } from '@/types/formTemplate';
import styles from './EntityFormSettingsPanel.module.scss';

// ============================================
// TYPES
// ============================================

interface EntityFormSettingsPanelProps {
  entry: FormTemplateFormEntry;
  onChange: (updated: FormTemplateFormEntry) => void;
}

// ============================================
// COMPONENT
// ============================================

function EntityFormSettingsPanel({
  entry,
  onChange,
}: EntityFormSettingsPanelProps) {
  const { t } = useTranslation();
  const handleIsMandatoryChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange({
        ...entry,
        attributes: { ...entry.attributes, isMandatory: e.target.checked },
      });
    },
    [entry, onChange],
  );

  return (
    <div className={styles.grid}>
      {/* Mandatory Form Checkbox */}
      <div className={styles.mandatoryCell}>
        <label className={styles.mandatoryLabel}>
          <input
            type="checkbox"
            checked={entry.attributes.isMandatory ?? false}
            onChange={handleIsMandatoryChange}
            className={styles.mandatoryCheckbox}
          />
          <span>{t('K_MANDATE_FORM_ENTITY', 'Mandate form while creating entity')}</span>
        </label>
      </div>
    </div>
  );
}

export default EntityFormSettingsPanel;
